import type { AdminLang, LangCode } from '../types.js';
import { ADMIN_STRINGS, type AdminKey } from './admin.js';
import { EMPLOYEE_STRINGS, type EmployeeKey } from './employee.js';

export { ADMIN_STRINGS, EMPLOYEE_STRINGS };
export type { AdminKey, EmployeeKey };

/** Supported employee-app languages, by native name. */
export const LANGS: Array<[LangCode, string]> = [
  ['is', 'Íslenska'], ['en', 'English'], ['pl', 'Polski'], ['lt', 'Lietuvių'],
  ['ro', 'Română'], ['es', 'Español'], ['lv', 'Latviešu'], ['sq', 'Shqip'],
  ['bg', 'Български'], ['de', 'Deutsch'], ['fr', 'Français'], ['uk', 'Українська'],
];

export const LANG_CODES = LANGS.map(([c]) => c);

export function isLangCode(v: string): v is LangCode {
  return (LANG_CODES as string[]).includes(v);
}

const DOW: Record<LangCode, string[]> = {
  is: ['sun', 'mán', 'þri', 'mið', 'fim', 'fös', 'lau'],
  en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  pl: ['nd', 'pn', 'wt', 'śr', 'czw', 'pt', 'sob'],
  lt: ['sk', 'pr', 'an', 'tr', 'kt', 'pn', 'št'],
  ro: ['du', 'lu', 'ma', 'mi', 'jo', 'vi', 'sâ'],
  es: ['do', 'lu', 'ma', 'mi', 'ju', 'vi', 'sá'],
  lv: ['sv', 'pi', 'ot', 'tr', 'ce', 'pk', 'se'],
  sq: ['die', 'hën', 'mar', 'mër', 'enj', 'pre', 'sht'],
  bg: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
  de: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  fr: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
  uk: ['нд', 'пн', 'вт', 'ср', 'чт', 'пт', 'сб'],
};

const MONTHS: Record<AdminLang, string[]> = {
  is: ['jan', 'feb', 'mar', 'apr', 'maí', 'jún', 'júl', 'ágú', 'sep', 'okt', 'nóv', 'des'],
  en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
};

/** Employee-app translator. Falls back to English, then to the key itself. */
export function t(lang: LangCode, key: EmployeeKey): string {
  return EMPLOYEE_STRINGS[lang]?.[key] ?? EMPLOYEE_STRINGS.en[key] ?? key;
}

/** Employer-portal translator. */
export function ta(lang: AdminLang, key: AdminKey): string {
  return ADMIN_STRINGS[lang]?.[key] ?? ADMIN_STRINGS.en[key] ?? key;
}

export function dow(lang: LangCode, index: number): string {
  return (DOW[lang] ?? DOW.en)[index];
}

export function month(lang: AdminLang, index: number): string {
  return MONTHS[lang][index];
}
